import { jsx as _jsx } from "react/jsx-runtime";
import { useWidgetI18n } from "../../context/WidgetI18nContext";
const fmt = (value) => Number.isFinite(value) ? value.toLocaleString("en-US", { maximumFractionDigits: 8 }) : "—";
/**
 * UX-03 — DOM alternative for the canvas chart.
 *
 * The engine renders to a bare `<canvas>`, which screen readers cannot read.
 * This region exposes the same essential facts as text, and is linked to the
 * chart container via `aria-describedby` so it is announced on focus without
 * interrupting pointer interaction.
 *
 * It is visually hidden (not `display:none`, which would remove it from the
 * accessibility tree) and polite, so data ticks do not spam a screen reader.
 */
export function ChartA11ySummary({ id, symbol, timeframe, ohlc, barCount, visibleRange, status, }) {
    const { t } = useWidgetI18n();
    const parts = [];
    parts.push(`${t("a11y.chart.symbol", { defaultValue: "Symbol" })}: ${symbol || "—"}`);
    parts.push(`${t("a11y.chart.timeframe", { defaultValue: "Timeframe" })}: ${timeframe || "—"}`);
    if (ohlc) {
        parts.push(`${t("a11y.chart.ohlc", { defaultValue: "OHLC" })}: ${fmt(ohlc.open)} / ${fmt(ohlc.high)} / ${fmt(ohlc.low)} / ${fmt(ohlc.close)}`);
    }
    parts.push(`${t("a11y.chart.bars", { defaultValue: "Bars" })}: ${barCount}`);
    if (visibleRange) {
        parts.push(`${t("a11y.chart.visibleRange", { defaultValue: "Visible range" })}: ${visibleRange.from}–${visibleRange.to}`);
    }
    if (status) {
        parts.push(`${t("a11y.chart.status", { defaultValue: "Status" })}: ${status}`);
    }
    return (_jsx("p", { id: id, "data-testid": "chart-a11y-summary", "data-bar-count": barCount, "data-visible-from": visibleRange?.from, "data-visible-to": visibleRange?.to, "aria-live": "polite", "aria-atomic": "true", style: {
            position: "absolute",
            width: "1px",
            height: "1px",
            margin: "-1px",
            padding: 0,
            overflow: "hidden",
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            whiteSpace: "nowrap",
            border: 0,
        }, children: parts.join(" · ") }));
}
